export const LOAD_PROPOSALS = 'LOAD_PROPOSALS'
export const BID_PROPOSAL_MARKED_WON = 'BID_PROPOSAL_MARKED_WON'
export const BID_PROPOSAL_DOWNLOAD_PROPOSAL = 'BID_PROPOSAL_DOWNLOAD_PROPOSAL'
export const BID_PROPOSAL_CREATE_PROPOSAL = 'BID_PROPOSAL_CREATE_PROPOSAL'